module.exports = __webpack_public_path__ + "img/hr-level2addon_idle.7034ec1e.png";